export class ChatSentEvent extends CustomEvent<string> {
   static EVENT_NAME = 'chat-message-sent';

   constructor(message: string) {
      super(ChatSentEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
         detail: message,
      });
   }
}

export class ChatInputUpdatedEvent extends CustomEvent<string> {
   static EVENT_NAME = 'atlantis-chat-update-input';
   constructor(message: string) {
      super(ChatInputUpdatedEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
         detail: message,
      });
   }
}

export class ChatFavoriteEvent extends Event {
   static EVENT_NAME = 'atlantis-chat-favorite';
   constructor() {
      super(ChatFavoriteEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}

export class ChatAddContactEvent extends Event {
   static EVENT_NAME = 'atlantis-chat-add-contact';
   constructor() {
      super(ChatAddContactEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}
